import {
  DamagedPartsSelectedQueryParamsType,
  DamagedPartsSelectedQueryResponseType,
} from '@/common/components/camera/queries/damagedPartsSelected/damagedPartsSelectedQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const damagedPartsSelectedFunction = (
  params: DamagedPartsSelectedQueryParamsType,
): Promise<DamagedPartsSelectedQueryResponseType> => {
  const url = () => {
    switch (params.params.participantRoleType) {
      case 'culprit':
      case 'damaged':
        return `/property/reports/${params.params.id}/accident_users/${params?.params?.participantRoleType}/images/damaged_parts_selected/`;
      case 'initial':
        return `/initial/reports/${params.params.id}/images/damaged_parts_selected/`;
      case 'body':
        return `/body/reports/${params.params.id}/images/damaged_parts_selected/`;

      default:
        return '';
    }
  };

  return fetchApi.get(url(), {
    params: {
      damaged_id: params.params.damaged_id,
    },
  });
};
